import { render } from "./MiniProgramInformationEdit.vue?vue&type=template&id=8bbabe28&scoped=true"
import script from "./MiniProgramInformationEdit.vue?vue&type=script&lang=js"
export * from "./MiniProgramInformationEdit.vue?vue&type=script&lang=js"

import "./MiniProgramInformationEdit.vue?vue&type=style&index=0&id=8bbabe28&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbabe28"],['__file',"src/views/h5/common/sys/miniProgram/information/MiniProgramInformationEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bbabe28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bbabe28', __exports__)) {
    api.reload('8bbabe28', __exports__)
  }
  
  module.hot.accept("./MiniProgramInformationEdit.vue?vue&type=template&id=8bbabe28&scoped=true", () => {
    api.rerender('8bbabe28', render)
  })

}


export default __exports__